import React from "react"
import { BodyText, InlineText, SubTitle } from "../../Typography/Typography"
import SmartLink from "../../layout/SmartLink/SmartLink"

const providerProfileClickEvent = () => ({
  name: "SEO Filtered Directory - Copy link to provider clicked",
  properties: {
    "Care Type": "care_home",
    "GEO Location": "Leicester",
    "Current URL":
      "https://www.caresourcer.com/s/providers/towns/leicester/care-home/",
  },
})

export default {
  summary: (
    <BodyText marginBottom>
      Choosing a care home for a loved one can be difficult, however with over
      120 care homes in Leicester, and 97 offering specialist dementia care, it
      is important you make the right decision on which care home is best for
      your loved one’s needs. Here are a few of our top tips to help you narrow
      your options.
    </BodyText>
  ),
  content: [
    <SubTitle marginBottom bold>
      Location is key
    </SubTitle>,
    <BodyText marginBottom>
      Transportation to care homes in and around Leicester should not be a
      problem, with over 120 care homes you should be able to find one in a
      location to suit. There are several care homes located centrally,
      including the{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-3004022901/elliott-residential-care-home"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Elliott Residential Care Home</InlineText>
      </SmartLink>
      , which is a 10-minute walk from the railway station. Or if the city
      center is not right for your loved one, for only for a short drive you can
      find a number of care homes in quieter locations such as{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-8372188795/george-hythe-house"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>George Hythe House</InlineText>
      </SmartLink>
      , which is only a few minutes walk from the Bennion Pools Fishing Lakes.
      It is our advice to think about where friends and family will be visiting
      from, then speak to the care homes directly as they can advise you about
      the public transport options or local car parking.
    </BodyText>,
    <SubTitle marginBottom bold>
      Feeling at home
    </SubTitle>,
    <BodyText marginBottom>
      Once you have decided on an area, it is important to consider the
      facilities available at the care home, and ensure you find one that will
      help your loved one feel at home. Whilst most of the care homes in
      Leicester will allow you to move in furniture or to add personal touches
      to the resident’s room, you need to consider what they enjoy doing with
      their days and find a home that can accommodate this.
    </BodyText>,
    <SubTitle marginBottom bold italic>
      Gardens and outdoor spaces
    </SubTitle>,
    <BodyText marginBottom>
      How important is outdoor space to your loved one? Do they simply want
      somewhere nice to sit with a cup of tea, or are they green fingered and
      like to help around the garden? With over 100 of the care homes in
      Leicester offering garden space there will be something to suit. Whether
      that is{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-2600747693/devonshire-court"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Devonshire Court</InlineText>
      </SmartLink>
      , which is surrounded by 4.5 acres of landscaped gardens and even has its
      own putting green, or something a little smaller, like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-1498831686/portland-house"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Portland House</InlineText>
      </SmartLink>{" "}
      in the Kirby Muxloe area, Leicester has something to meet everyone&apos;s
      needs.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Pets welcome
    </BodyText>,
    <BodyText marginBottom>
      Does your loved one have a pet and is worried about leaving them when they
      move into a care home, or do they have allergies to pet hair? With over 80
      pet-friendly care homes in Leicester, it is recommended to understand the
      home’s pet policy is, as some allow pets to move in with their owner and
      others allow pets to visit on appointment.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Activities and days out
    </BodyText>,
    <BodyText marginBottom>
      Most care homes work hard to offer residents a mix of spaces to relax in
      and spaces that will be a hive of activity. Homes in Leicester are no
      different with many offering a number of on-site facilities including
      libraries, cinemas, cafes and a range of group-based activities. Many,
      like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-3086808581/cedar-mews"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Cedar Mews</InlineText>
      </SmartLink>
      , also try to organise outings to local attractions in and around
      Leicester, whether it’s for a pint down at the local bar, a visit to
      Birstall Fisheries, or a trip to the local garden centre. If your loved
      one has anything they love to do, make sure to speak to the home about how
      they could accommodate this.
    </BodyText>,
  ],
}
